import type { FC } from "react";

import type { RepositoryChatConversation } from "../../dashboard-client";
import type { SourceControlRepository } from "../../types";
import type { RepositoryChatRetrievalMode } from "./repositoryChatModels";

import { PanelHeaderBlock } from "../common/PanelHeaderBlock";
import { RepositoryChatBuilderSection } from "./RepositoryChatBuilderSection";
import { RepositoryChatConversationList } from "./RepositoryChatConversationList";

interface RepositoryChatSidebarProps {
  conversations: RepositoryChatConversation[];
  creatingConversation: boolean;
  loadingConversations: boolean;
  loadingRepositories: boolean;
  onCreateConversation: () => void;
  onRepoSearchChange: (value: string) => void;
  onRetrievalModeChange: (value: RepositoryChatRetrievalMode) => void;
  onSelectConversation: (conversationId: string) => void;
  onToggleRepository: (repository: SourceControlRepository) => void;
  repoSearch: string;
  repositories: SourceControlRepository[];
  retrievalMode: RepositoryChatRetrievalMode;
  selectedConversationId: string | null;
  selectedRepositorySlugs: string[];
}

export const RepositoryChatSidebar: FC<RepositoryChatSidebarProps> = (
  props,
) => (
  <div className="flex h-full w-80 flex-col overflow-hidden border-r border-slate-200 bg-white shadow-xl lg:shadow-sm dark:border-slate-700 dark:bg-arti-panel">
    <div className="border-b border-slate-200 bg-slate-50 px-4 py-3 dark:border-slate-700 dark:bg-arti-panel/80">
      <PanelHeaderBlock eyebrow="Repository Chat" title="Context Rail" />
    </div>

    <div className="min-h-0 flex-1 space-y-5 overflow-y-auto p-4">
      <RepositoryChatBuilderSection
        creatingConversation={props.creatingConversation}
        loadingRepositories={props.loadingRepositories}
        onCreateConversation={props.onCreateConversation}
        onRepoSearchChange={props.onRepoSearchChange}
        onRetrievalModeChange={props.onRetrievalModeChange}
        onToggleRepository={props.onToggleRepository}
        repoSearch={props.repoSearch}
        repositories={props.repositories}
        retrievalMode={props.retrievalMode}
        selectedRepositorySlugs={props.selectedRepositorySlugs}
      />
      <RepositoryChatConversationList
        conversations={props.conversations}
        loadingConversations={props.loadingConversations}
        onSelectConversation={props.onSelectConversation}
        selectedConversationId={props.selectedConversationId}
      />
    </div>
  </div>
);
